import { createContext, useContextSelectors } from '@fluentui/react-bindings';
import { defaultChatDensity } from './chatDensity';
var ChatContext = createContext({
  density: defaultChatDensity,
  behaviors: {
    item: undefined,
    message: undefined
  }
});
export var ChatContextProvider = ChatContext.Provider;
export var useChatContextSelectors = function useChatContextSelectors(selectors) {
  return useContextSelectors(ChatContext, selectors);
};